import React from 'react';
import { user_access_token, user_access_level } from 'Api/Api';
import Steps from 'pages/PKCreation/PKCreationSteps/Steps';
import EmptyMessage from 'components/EmptyMessage/EmptyMessage';
import axios from 'axios';
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import { withRouter } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import "./style.css";
import { organization_user_access_level, org_friendly_url, apiUrl, user_Status, user_entity_uuid, myHeaders_Auth_With_Cache_Control } from 'Api/Api';
import PresentationDescription from 'pages/PKCreation/PKCreationSteps/Description/PresentationDescription';
import PresentationSlides from 'pages/PKCreation/PKCreationSteps/Slides/PresentationSlides';
import PresentationAudio from 'pages/PKCreation/PKCreationSteps/Audio/PresentationAudio';

// import PublishButton from 'components/PublishButton/PublishButton';
// import DownloadAssetsButton from 'components/DownloadAssetsButton/DownloadAssetsButton';
import ShareAccessModalButton from 'components/Modals/ShareAccessModalButton';

import { local_routes } from 'utils/Routes';

class PKCreateTabs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            //presentation_uuid: props.received_props.entity_uuid,
            step_array: [],
            pk_info: {},
            allowed: true,
            step: 0,
            allow_audio: false,
            //descriptionTabData: null,
            //VenueTabData: null,
            //recDesData: null,
            //recVenData: null,
            loading:true,
            //channelData:null,
            //redirect:false,
        };
        
        this.default_slide_length = 20;
        this.default_slide_count = 20;
        
        //this.next = this.next.bind(this);
        this.workspace_base_url = "";
        if (org_friendly_url) {
          this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
        }

        /*
        this.presentation_uuid = "";
        this.otherpage = "";
        if (props.received_props.entity_uuid) {
            this.presentation_uuid = this.props.received_props.entity_uuid;
        }
        if (props.received_props.otherpage) {
            this.otherpage = this.props.received_props.otherpage;
        }
        */
        
        
    }

    componentDidUpdate (prevProps) {
        //console.log("YO",prevProps);
        let { location: { pathname } } = this.props;

        if (prevProps.location.pathname === pathname) return;
        this.routeChanged();
    }

    routeChanged () {
        console.log("routeChanged PKCreateTabs");
        this.setupPage();
        //this.setState({ step: 1});
        //this.forceUpdate();
        //this.APIPromises();
    }

    setupPage = async () => {
        let presentation_uuid = "";
        let otherpage = "";
        let new_state = {...this.state};

        if (!user_access_token || user_Status !== 1) {
            // must be logged in to continue
            this.setState({allowed:false});
            return;
        }

        if (this.props.received_props.entity_uuid) {
            presentation_uuid = this.props.received_props.entity_uuid;
        }
        if (this.props.received_props.otherpage) {
            otherpage = this.props.received_props.otherpage;
        }

        new_state.allow_audio = false;

        // if editing a PK, make sure user is allowed to edit this PK
        if (presentation_uuid) {
            // JBB - 10/26/2019 - need to make sure user has access
            //console.log("YO",user_access_token,user_Status,user_Status_Ver);
            let params = {
                sort_obj: {
                    order_integer: 'asc'
                },
                filter_obj: {
                    order_integer: {
                        gte: 1
                    }
                }
            }
            let api_promises = [
                axios.get(`${apiUrl}presentations/${presentation_uuid}`, myHeaders_Auth_With_Cache_Control),
                axios.get(`${apiUrl}presentations/${presentation_uuid}/slides`, { params, ...myHeaders_Auth_With_Cache_Control }),
                //axios.get(`${apiUrl}presentations/${this.props.presentation_uuid}/categories`, myHeaders_Auth_With_Cache_Control)
            ];
            if (user_access_level !== "admin" && organization_user_access_level !== 'admin') {
                api_promises.push(axios.get(`${apiUrl}presentations/${presentation_uuid}/users`, myHeaders_Auth_With_Cache_Control));
            }

            try {
                let [pk_response,pk_slides_response,pk_users_response] = await Promise.all(api_promises);

                if (pk_users_response) {
                    // not admin - must check ownership
                    let owner_match = false;
                    for (let pk_user of pk_users_response.data) {
                        if (pk_user.entity_uuid === user_entity_uuid) {
                            if (pk_user.xref_data && pk_user.xref_data.entity_owner_integer && pk_user.xref_data.entity_owner_integer >= 1) {
                                owner_match = true;
                                break;
                            }
                        }
                    }
                    if (!owner_match) {
                        this.setState({allowed:false});
                        return;
                    }
                }
                
                new_state.pk_info = pk_response.data;
                if (!new_state.pk_info.slide_length) {
                    new_state.pk_info.slide_length = this.default_slide_length;
                }
                if (!new_state.pk_info.slide_count) {
                    new_state.pk_info.slide_count = this.default_slide_count;
                }
                
                //new_state.categories = pk_categories_response.data;
                
                new_state.slides = pk_slides_response.data;
                
                if (new_state.slides.length >= new_state.pk_info.slide_count) {
                    new_state.allow_audio = true;
                }

            } catch (err) {
                this.setState({allowed:false});
                return;
            }
            
            //console.log("CHECK",new_state.allow_audio,new_state.pk_info.slide_count,new_state.slides.length);
            
            let audio_link = "";
            if (new_state.allow_audio) {
                audio_link = this.workspace_base_url+local_routes.pkcreation+'/'+presentation_uuid+'/audio';
            }
            
            // populate steps with links
            new_state.step_array = [
                {
                    step_name: 'Description',
                    link: this.workspace_base_url+local_routes.pkcreation+'/'+presentation_uuid+'/description'
                },
                {
                    step_name: 'Images',
                    link: this.workspace_base_url+local_routes.pkcreation+'/'+presentation_uuid+'/slides'
                },
                {
                    step_name: 'Audio',
                    link: audio_link
                }
            ];
        } else {
            new_state.pk_info = {};
            new_state.step_array = [
                {
                    step_name: 'Description'
                },
                {
                    step_name: 'Images'
                },
                {
                    step_name: 'Audio'
                }
            ];
        }
        
        //console.log("HI",presentation_uuid,otherpage,this.props);
        
        if (otherpage === "description") {
            new_state.step = 1;
        } else if (otherpage === "slides") {
            new_state.step = 2;
        } else if (otherpage === "audio") {
            if (new_state.allow_audio) {
                new_state.step = 3;
            } else {
                new_state.step = 2;
            }
        } else {
            // no otherpage or otherpage not recognized - go to description tab
            new_state.step = 1;
        }
        
        //new_state.presentation_uuid = presentation_uuid;
        new_state.loading = false;
        this.setState(new_state);
    }

    
    componentDidMount = async function () {
        this.setupPage();
    }        
        
    next = () => {
        console.log("NEXT",this.state.step);
        //this.setState({
        //    step: this.state.step + 1,
        //});
    }

    prev = () => {
        console.log("PREV",this.state.step);
        //this.setState({
        //    step: this.state.step - 1,
        //});
    }

    render() {
        
        //console.log("RENDER PKCreationTabs",this.props.received_props.entity_uuid);

        if (!user_access_token) {
            return (
                <EmptyMessage empty_message="Please Login/Register to create a PK" />
            );
        }
        
        if (!this.state.allowed) {
            return (
                <EmptyMessage empty_message="Not allowed to edit this PK" />
            );
        }
        
        if (this.state.loading === true) {
            return (
                <ActivityIndicator theme="spinner" />
            );
        }
        
        
        switch (this.state.step) {
            case 1:
                return (
                    <div>
                        { this.state.pk_info.entity_name &&
                          <Container>
                            <Row xs={4} md={4} style={{ marginLeft: '-25px', marginTop: '-20px', marginBottom: '10px'}}>
                              <Col>
                                Title: "{this.state.pk_info.entity_name}"
                              </Col>
                              <Col>
                                <ShareAccessModalButton
                                  entity_info={{...this.state.pk_info,entity_type:'presentations'}}
                                  //OnChangePublishOption={this.OnChangePublishOption}
                                  //index={props.index}
                                />
                              </Col>
                            </Row>
                          </Container>
                        }
                        <Steps step_array={this.state.step_array} step={this.state.step} />
                        <PresentationDescription
                            pk_info={this.state.pk_info}
                            presentation_uuid={this.props.received_props.entity_uuid}
                            //{...this.props}
                            next={() => this.next()}
                            source_info={this.props.received_source_info}
                        />
                    </div>                    
                );
            case 2:
                return (
                    <div>
                        { this.state.pk_info.entity_name &&
                          <Container>
                            <Row xs={4} md={4} style={{ marginLeft: '-25px', marginTop: '-20px', marginBottom: '10px'}}>
                              <Col>
                                Title: "{this.state.pk_info.entity_name}"
                              </Col>
                              <Col>
                                <ShareAccessModalButton
                                  entity_info={{...this.state.pk_info,entity_type:'presentations'}}
                                  //OnChangePublishOption={this.OnChangePublishOption}
                                  //index={props.index}
                                />
                              </Col>
                            </Row>
                          </Container>
                        }
                        {/*
                        { this.state.pk_info.entity_name &&
                            <div style={{ marginLeft: '-15px', marginTop: '-20px', marginBottom: '10px'}}>Title: "{this.state.pk_info.entity_name}"</div>
                        }
                        */}
                        <Steps step_array={this.state.step_array} step={this.state.step} />
                        <PresentationSlides
                            pk_info={this.state.pk_info}
                            presentation_uuid={this.props.received_props.entity_uuid}
                            //{...this.props}
                            next={() => this.next()}
                            prev={() => this.prev()}
                            source_info={this.props.received_source_info}
                        />
                    </div>
                );
            case 3:
                return (
                    <div>
                        { this.state.pk_info.entity_name &&
                          <Container>
                            <Row xs={4} md={4} style={{ marginLeft: '-25px', marginTop: '-20px', marginBottom: '10px'}}>
                              <Col>
                                Title: "{this.state.pk_info.entity_name}"
                              </Col>
                              <Col>
                                <ShareAccessModalButton
                                  entity_info={{...this.state.pk_info,entity_type:'presentations'}}
                                  //OnChangePublishOption={this.OnChangePublishOption}
                                  //index={props.index}
                                />
                              </Col>
                            </Row>
                          </Container>
                        }
                        {/*
                        { this.state.pk_info.entity_name &&
                            <div style={{ marginLeft: '-15px', marginTop: '-20px', marginBottom: '10px'}} className="pk-title-header-display">Title: "{this.state.pk_info.entity_name}"</div>
                        }
                        */}
                        <Steps step_array={this.state.step_array} step={this.state.step} />
                        <PresentationAudio
                            pk_info={this.state.pk_info}
                            presentation_uuid={this.props.received_props.entity_uuid}
                            //{...this.props}
                            next={() => this.next()}
                            prev={() => this.prev()}
                            source_info={this.props.received_source_info}
                        />
                    </div>
                );
            default:
                return null
        }
    }
}

export default withRouter(PKCreateTabs);
